import React, { useEffect } from "react";
import { useState } from "react";
import { IoChevronForwardOutline } from "react-icons/io5";
import { Popup } from "semantic-ui-react";
import axios from "../../../../axios";
import ResolveQueryLib from "./resolveQueryLib";
import NestedReply from "../../../../Engagement/StudentQuery/Reply Query/NestedReply";
import moment from "moment";
import EditReply from "../../../../Engagement/StudentQuery/Reply Query/ThreeDot_Edit _Delete/EditReply";
import EditReplyLib from "./EditReply";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";
import DeleteQueryLib from "./DeleteQueryLib";
import CreateBookMarkPopup from "./CreateBookMarkPopup";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";

import {
  Avatar,
  Button,
  IconButton,
  Chip,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ReplyIcon from "@mui/icons-material/Reply";
import { CircularProgress } from "@mui/material";

function ReplyMenu({
  canEdit = false,
  onEdit = () => { },
  onDelete = () => { },
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="ml-1"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        keepMounted
      >
        {canEdit && (
          <MenuItem
            onClick={() => {
              onEdit();
              setAnchorEl(null);
            }}
          >
            Edit
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            onDelete();
            setAnchorEl(null);
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  );
}

export default function Query({
  book,
  chapter,
  userDetail,
  bookId,
  chapterId,
  grpId1,
  setEditQuery2,
  setIsUpdate1,
  componentRerenderFlag,
  setComponentRerenderFlag,
  setOpenQueryDialog,
  isLoading,
  setIsLoading,
}) {
  const [showReply, setShowReply] = useState([]);
  const [editQuery, setEditQuery] = useState(false);
  const [deleteQuery, setDeleteQuery] = useState(false);
  const [replyQuery, setReplyQuery] = useState(false);
  const [allQuery, setAllQuery] = useState([]);
  const [clickedQuery, setClickedQuery] = useState(false);
  const [markQuery, setMarkQuery] = useState(false);
  const [reply, setReply] = useState([]);
  const [forReply, setForReply] = useState();
  const [userReplu, setUserReply] = useState();
  const [errorMsg, setErrorMsg] = useState("");
  const [viewErrorPop, setViewErrorPop] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isRepliesLoading, setIsRepliesLoading] = useState(false);
  const [replyLoading, setReplyLoading] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const [replyLoader, setReplyLoader] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    if (!grpId1) {
      setAllQuery([]);
      setIsLoading(false);
      return;
    }

    const fetchQueries = async () => {
      setIsLoading(true);

      try {
        const res = await axios.get(
          `/query/getForStudent/${userDetail?.id}/groupId/${grpId1}?chapterId=${chapterId}&bookId=${bookId?.id}`
        );

        setAllQuery(Array.isArray(res.data.data) ? res.data.data : []);
      } catch (err) {
        setAllQuery([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchQueries();
  }, [grpId1, componentRerenderFlag]);

  console.log(isLoading, "isLoading");
  console.log(allQuery, "allQuery");

  function getTimeAMPM(timestamp) {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedTime = `${formattedHours}:${minutes < 10 ? "0" : ""
      }${minutes} ${ampm}`;
    return formattedTime;
  }
  const [likedReplies, setLikedReplies] = useState([]);
  const [likeCounts, setLikeCounts] = useState([]);
  useEffect(() => {
    const initialLikedReplies = reply.map((obj) =>
      obj.likes.includes(userDetail.id)
    );
    setLikedReplies(initialLikedReplies);
    const initialLikeCounts = reply.map((obj) => obj.likes.length);
    setLikeCounts(initialLikeCounts);
  }, [reply, userDetail.id]);

  useEffect(() => {
    setShowReply(new Array(allQuery.length).fill(false));
  }, [allQuery]);

  const toggleReply = (index) => {
    setShowReply((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index]; // toggle
      return newState;
    });

    setClickedQuery(allQuery[index]); // replies load hone ke liye
  };

  useEffect(() => {
    setIsRepliesLoading(true);
    try {
      if (clickedQuery?.id) {
        const handleReply = async () => {
          let res = await axios.get(`/query/reply/get/${clickedQuery?.id}`);
          setReply(res.data.data);
        };
        handleReply();
      }
    } catch (error) {
      console.log(error);
      if (error) {
        setErrorMsg(error.response.data.message);
        setViewErrorPop(true);
      }
    } finally {
      setIsRepliesLoading(false);
    }
  }, [clickedQuery]);
  function getFirstCharacterOfFirstName(fullName) {
    const nameParts = fullName.trim().split(" ");
    if (nameParts.length > 0) {
      const firstName = nameParts[0];
      return firstName.charAt(0).toUpperCase();
    } else {
      return "N/A";
    }
  }
  const handleLikeClick = (index) => {
    const newLikedReplies = [...likedReplies];
    const newLikeCounts = [...likeCounts];
    newLikedReplies[index] = !newLikedReplies[index];
    if (newLikedReplies[index]) {
      newLikeCounts[index]++;
      axios
        .put(`/query/reply/like/${reply[index].id}`, {
          user_id: userDetail?.id,
        })
        .then((res) => {
          console.log(res);
        });
    } else {
      newLikeCounts[index]--;
    }
    setLikedReplies(newLikedReplies);
    setLikeCounts(newLikeCounts);
  };
  const [deletedReplies, setDeletedReplies] = useState(
    new Array(reply.length).fill(false)
  );
  const handleDeleteReply = (index) => {
    const updatedDeletedReplies = [...deletedReplies];
    updatedDeletedReplies[index] = true;
    setDeletedReplies(updatedDeletedReplies);
  };
  const delteLogic = async (index) => {
    let user_id = userDetail?.id;
    let res = await axios.delete(`/query/reply/delete/${reply[index].id}`, {
      data: { user_id },
    });
    console.log(res);
  };
  const [replycreate, setReplycreate] = useState("");
  const handleFetchQuery = async () => {
    let res = await axios.get(`/query/reply/get/${clickedQuery?.id}`);
    setReply(res.data.data);
  };
  const handleCreateReply = async () => {
    try {
      setReplyLoading(true);
      let body = {
        user_id: userDetail.id,
        reply: replycreate,
        attachments: [],
      };
      let res = await axios.post(
        `/query/${clickedQuery.id}/reply/create`,
        body
      );
      if (res.status === 201) {
        setReplycreate("");
        handleFetchQuery();
      }
    } catch (error) {
    } finally {
      setReplyLoading(false);
    }
  };
  const handleParentReply = async () => {
    try {
      setReplyLoading(true);
      let body = {
        user_id: userDetail.id,
        reply: replycreate,
        attachments: [],
      };
      let res = await axios.post(
        `/query/${clickedQuery.id}/${userReplu.id}/reply/create`,
        body
      );
      if (res.status === 201) {
        setReplycreate("");
        handleFetchQuery();
        setReplyQuery(false);
      }
    } catch (error) {
    } finally {
      setReplyLoading(false);
    }
  };
  const formatCreatedAt = (createdAt) => {
    return moment(createdAt).calendar({
      sameDay: "h:mm A",
      lastDay: "[Yesterday]",
      lastWeek: "DD MMM YYYY",
      sameElse: "DD MMM YYYY",
    });
  };
  const [editReplyIndex, setEditReplyIndex] = useState(-1);
  const [edit, setEdit] = useState();
  const [editQuery1, setEditQuery1] = useState();
  useEffect(() => {
    setEditQuery1(editQuery1);
  }, [editQuery1]);

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: true,
    });
  };

  if (isLoading) {
    return (
      <div className="w-full flex justify-center py-10">
        <CircularProgress style={{ color: "#F97316" }} size={42} />
      </div>
    );
  }

  if (!isLoading && allQuery.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <h3 className="text-xl font-semibold text-gray-700">No Queries Yet</h3>

        <p className="text-gray-500 mt-1">
          You haven’t added any queries so far.
        </p>

        <button
          onClick={() => setOpenQueryDialog(true)}
          className="mt-4 px-4 py-2 rounded-lg bg-orange-500 text-white font-medium hover:bg-orange-600"
        >
          + Add Your First Query
        </button>
      </div>
    );
  }
  return (
    allQuery &&
    allQuery.length > 0 &&
    allQuery.map((obj, index) => (
      <div key={index} className="bg-white rounded-lg shadow p-4 mt-4">
        <div className="flex justify-between items-start gap-4">
          <div className="flex items-center gap-4 min-w-0">
            {/* STATUS BADGE */}
            <div className="flex-shrink-0">
              <span
                className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${obj.status === "resolved"
                  ? "bg-green-100 text-green-800"
                  : obj.status === "approved"
                    ? "bg-blue-100 text-blue-800"
                    : obj.status === "pending"
                      ? "bg-yellow-100 text-yellow-800"
                      : "bg-red-100 text-red-800"
                  }`}
              >
                {obj.status === 'approved' ? 'ACTIVE' : obj.status?.toUpperCase?.()}
              </span>
            </div>

            {/* BOOK -> CHAPTER */}
            <div className="text-sm text-gray-600 flex items-center gap-2 truncate">
              <span className="font-medium text-gray-800 truncate">{book}</span>
              <IoChevronForwardOutline className="text-gray-400" />
              <span className="truncate">{chapter}</span>
            </div>

            {/* TAGS */}
            <div className="flex gap-2 flex-wrap ml-2">
              {obj.tags?.map((tag, tIdx) => (
                <Chip
                  key={`${tag}-${tIdx}`}
                  label={tag}
                  size="small"
                  className="!bg-gray-100 !text-gray-700"
                />
              ))}
            </div>
          </div>

          {/* Toggle replies for approved/resolved */}
          <div className="flex items-center gap-2">
            {(obj.status === "approved" || obj.status === "resolved") && (
              <button
                className="p-2 rounded hover:bg-gray-100"
                onClick={() => {
                  toggleReply(index);
                  setClickedQuery(obj);
                }}
                aria-label="toggle replies"
              >
                <img
                  src={
                    showReply[index]
                      ? "/LibraryImg/UpwordArrow.svg"
                      : "/LibraryImg/downArrow.svg"
                  }
                  alt="toggle"
                  className="w-5 h-5"
                />
              </button>
            )}
          </div>
        </div>

        {/* QUERY BODY */}
        <div className="mt-4">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            {/* Left: query title and meta */}
            <div className="min-w-0">
              <div className="flex items-center gap-3 flex-wrap">
                <h3 className="text-lg font-semibold text-gray-800 truncate">
                  {obj.query}
                </h3>

                <span className="text-sm text-gray-500">
                  {obj.reply_count} replies
                </span>

                <span className="text-sm text-gray-400">
                  • {getTimeAMPM(obj.updated_at)}
                </span>

                {/* Avatar */}
                <Avatar
                  alt={obj.user_id?.name}
                  src={
                    obj?.user_id?.profile_picture
                      ? IP + obj?.user_id?.profile_picture.replace(/^\./, "")
                      : obj?.user_id?.gender === "M"
                        ? obj?.user_id?.avatarProfile
                          ? "/images/Boys/" +
                          obj?.user_id?.avatarProfile +
                          ".webp"
                          : "/images/Student_boy_pic.png"
                        : obj?.user_id?.gender === "F"
                          ? obj?.user_id?.avatarProfile
                            ? "/images/Girls/" +
                            obj?.user_id?.avatarProfile +
                            ".webp"
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  sx={{ width: 36, height: 36 }}
                  onError={(e) => {
                    e.target.src =
                      obj?.user_id?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : obj?.user_id?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default image.png";
                  }}
                />

                <div className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                  {obj.user_id.id === userDetail.id ? "You" : obj.user_id.name}
                </div>
              </div>

              <p className="mt-2 text-gray-700">{obj.description}</p>

              {/* ATTACHMENTS */}
              {obj.attachments?.length > 0 && (
                <div className="mt-3 flex gap-3 flex-wrap">
                  {obj.attachments.map((attachment, aIdx) => {
                    const ext = (
                      attachment.split(".").pop() || ""
                    ).toLowerCase();
                    const isImage = ["jpg", "jpeg", "png"].includes(ext);
                    const isVideo = ext === "mp4";
                    return (
                      <div
                        key={aIdx}
                        onClick={() => {
                          // keep your existing viewer handlers
                          if (isVideo) handleClick(attachment);
                          else if (isImage) handleClick(attachment);
                          else {
                            setPedingSubDetail({
                              ...pedingSubDetail,
                              pdfView: true,
                            });
                            handleClickforpdf(attachment);
                          }
                        }}
                        className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-md cursor-pointer hover:shadow-sm"
                      >
                        <img
                          src={
                            iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment.substring(
                                  attachment.lastIndexOf(".") + 1
                                )
                            )?.icon || "/images/file-icon.png"
                          }
                          alt={ext}
                          className="w-6 h-6"
                        />
                        <div className="text-sm text-gray-700 max-w-[180px] truncate">
                          {attachment.replace(/^[^_]*_/, "")}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Right: avatar, author, actions */}
            <div className="flex items-center gap-3">
              {/* Mark as Resolved button */}
              {obj.status === "approved" && (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    setMarkQuery(true);
                    setClickedQuery(obj);
                  }}
                  sx={{
                    backgroundColor: "#10B981",
                    color: "white",
                    textTransform: "none",
                    ml: 1,
                  }}
                >
                  Mark as Resolved
                </Button>
              )}

              {/* Edit / Delete for pending or rejected */}
              {(obj.status === "pending" || obj.status === "rejected") && (
                <div className="flex items-center gap-2 ml-2">
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                      setEditQuery2(obj);
                      setOpenQueryDialog(true);
                      setIsUpdate1(true);
                    }}
                    sx={{
                      backgroundColor: "#F97316",
                      color: "white",
                      textTransform: "none",
                    }}
                  >
                    Edit
                  </Button>

                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                      setDeleteQuery(true);
                      setClickedQuery(obj);
                    }}
                    sx={{
                      backgroundColor: "#EF4444",
                      color: "white",
                      textTransform: "none",
                    }}
                  >
                    Delete
                  </Button>
                </div>
              )}
            </div>
          </div>

          {/* ------------------ CENTER DIVIDER LIKE EMAIL / THREAD ------------------- */}
          {(obj.status === "approved" || obj.status === "resolved") && (
            <div className="relative my-6 text-center">
              <div className="border-t"></div>
              <span className="absolute left-1/2 -translate-x-1/2 -top-3 bg-white px-3 text-gray-500 text-sm">
                {obj.reply_count} replies
              </span>
            </div>
          )}

          {showReply[index] && (
            <div className="mt-4 space-y-4">
              {/* Map replies */}

              {isRepliesLoading ? (
                <div className="flex justify-center py-6">
                  <div className="w-8 h-8 border-4 border-orange-400 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                <>
                  {reply?.length > 0 &&
                    reply.map((object, rIndex) => {
                      const isOwn = object.user_id.id === userDetail.id;
                      return (
                        <div key={rIndex} className="flex items-start gap-3">
                          {/* Left avatar for others, empty for own */}
                          {!isOwn && (
                            <div className="flex-shrink-0">
                              <div className="w-9 h-9 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-semibold">
                                {getFirstCharacterOfFirstName(
                                  object.user_id.name
                                )}
                              </div>
                            </div>
                          )}

                          <div
                            className={`flex-1 ${isOwn ? "ml-auto max-w-[75%]" : "max-w-[75%]"
                              }`}
                          >
                            <div
                              className={`flex items-start ${isOwn ? "justify-end" : "justify-start"
                                }`}
                            >
                              <div
                                className={`${isOwn ? "order-2" : "order-1"
                                  } flex flex-col`}
                              >
                                <div
                                  className={`px-4 py-2 rounded-xl ${isOwn
                                    ? "bg-orange-50 text-right"
                                    : "bg-white text-left"
                                    } border`}
                                >
                                  <div className="flex items-center justify-between gap-3">
                                    <div className="text-sm font-medium text-gray-800">
                                      {object.user_id.name}
                                    </div>
                                    <div className="text-xs text-gray-400">
                                      {formatCreatedAt(object.created_at)}
                                    </div>
                                  </div>

                                  {/* reply content or edit UI */}
                                  <div className="mt-2 text-sm text-gray-700">
                                    {editReplyIndex === rIndex ? (
                                      <EditReplyLib
                                        reply={edit}
                                        setReply={setEdit}
                                        setClickEditReply={() =>
                                          setEditReplyIndex(-1)
                                        }
                                        userDetails={userDetail}
                                        refetch={handleFetchQuery}
                                      />
                                    ) : deletedReplies[rIndex] ? (
                                      <div className="text-sm text-red-500">
                                        You can no longer see this message
                                      </div>
                                    ) : (
                                      <>
                                        {object.parent_reply_id && (
                                          <div className="mb-2">
                                            <NestedReply
                                              parentReply={
                                                object.parent_reply_id
                                              }
                                            />
                                          </div>
                                        )}
                                        <div>{object.reply}</div>
                                      </>
                                    )}
                                  </div>

                                  {/* reply attachments */}
                                  {object.attachments?.length > 0 && (
                                    <div className="mt-3 flex gap-3 flex-wrap">
                                      {object.attachments.map(
                                        (attachment, aI) => {
                                          const ext = (
                                            attachment.split(".").pop() || ""
                                          ).toLowerCase();
                                          const isImg = [
                                            "jpg",
                                            "jpeg",
                                            "png",
                                          ].includes(ext);
                                          return (
                                            <div
                                              key={aI}
                                              className="flex items-center gap-2 bg-gray-50 border px-3 py-2 rounded-md cursor-pointer"
                                              onClick={() => {
                                                if (!isError)
                                                  handleClick(attachment);
                                              }}
                                            >
                                              <img
                                                className="w-6 h-6"
                                                src={
                                                  iconData?.find(
                                                    (i) => i.extension === ext
                                                  )?.icon ||
                                                  "/images/file-icon.png"
                                                }
                                                alt={ext}
                                              />
                                              <div className="text-sm text-gray-700 truncate max-w-[200px]">
                                                {attachment.replace(
                                                  /^[^_]*_/,
                                                  ""
                                                )}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  )}
                                </div>

                                {/* action row below bubble */}
                                <div
                                  className={`mt-2 flex items-center gap-4 text-sm ${isOwn ? "justify-end" : ""
                                    }`}
                                >
                                  {/* Reply action */}
                                  <div
                                    className="flex items-center gap-1 cursor-pointer"
                                    onClick={() => {
                                      if (obj.status === "approved") {
                                        setReplyQuery(true);
                                        setForReply(object.reply);
                                        setUserReply(object);
                                      }
                                    }}
                                  >
                                    <img
                                      src="/LibraryImg/Replie.png"
                                      alt="reply"
                                    />
                                    <span className="text-gray-600">Reply</span>
                                  </div>

                                  {/* Like */}
                                  <div
                                    className="flex items-center gap-1 cursor-pointer"
                                    onClick={() => {
                                      if (obj.status === "approved") {
                                        const newLikedStatus = [
                                          ...likedReplies,
                                        ];
                                        newLikedStatus[rIndex] =
                                          !likedReplies[rIndex];
                                        setLikedReplies(newLikedStatus);
                                        handleLikeClick(rIndex);
                                      }
                                    }}
                                  >
                                    <img
                                      src={
                                        likedReplies[rIndex]
                                          ? "/LibraryImg/LikeQuery.png"
                                          : "/LibraryImg/Unlike.png"
                                      }
                                      alt="like"
                                      className="w-5 h-5"
                                    />
                                    <span className="text-gray-600">
                                      {likeCounts[rIndex] || 0}
                                    </span>
                                  </div>

                                  {/* three-dot menu */}
                                  <div className="ml-2">
                                    <ReplyMenu
                                      canEdit={obj.status === "approved"}
                                      onEdit={() => {
                                        setEditQuery(true);
                                        setEditReplyIndex(rIndex);
                                        setEdit(object);
                                      }}
                                      onDelete={() => {
                                        handleDeleteReply(rIndex);
                                        delteLogic(rIndex);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* own avatar on right */}
                          {isOwn && (
                            <div className="flex-shrink-0">
                              <div className="w-9 h-9 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-semibold">
                                {getFirstCharacterOfFirstName(
                                  object.user_id.name
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </>
              )}

              {/* Reply composer */}
              <div className="mt-2 p-3 bg-white rounded-md border">
                {replyQuery && (
                  <div className="mb-3 p-2 bg-gray-50 rounded">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center">
                          {getFirstCharacterOfFirstName(userReplu.user_id.name)}
                        </div>
                        <div>
                          <div className="text-sm font-medium">
                            {userReplu.user_id.name}
                          </div>
                          <div className="text-xs text-gray-400">
                            {formatCreatedAt(userReplu.created_at)}
                          </div>
                        </div>
                      </div>

                      <div>
                        <img
                          onClick={() => setReplyQuery(false)}
                          className="w-5 h-5 cursor-pointer"
                          src="/LibraryImg/crossIconQuery.png"
                          alt="close"
                        />
                      </div>
                    </div>
                    <div className="mt-2 ml-4 pl-2 text-sm text-gray-700">
                      {forReply}
                    </div>
                  </div>
                )}

                <div className="flex items-center gap-3">
                  {/* INPUT */}
                  <input
                    className="flex-1 border rounded px-3 py-2 focus:outline-none disabled:bg-gray-100"
                    placeholder="Type message"
                    disabled={obj.status !== "approved" || replyLoading}
                    value={replycreate}
                    maxLength={250}
                    onChange={(e) => setReplycreate(e.target.value)}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        replycreate.trim() &&
                        !replyLoading
                      ) {
                        replyQuery ? handleParentReply() : handleCreateReply();
                      }
                    }}
                  />

                  {/* SEND BUTTON */}
                  {obj.status === "approved" && (
                    <button
                      disabled={replyLoading}
                      className={`ml-2 p-2 rounded text-white flex items-center justify-center 
        ${replyLoading
                          ? "bg-orange-300 cursor-not-allowed"
                          : "bg-orange-500 hover:bg-orange-600"
                        }`}
                      onClick={() => {
                        if (!replyLoading) {
                          replyQuery
                            ? handleParentReply()
                            : handleCreateReply();
                        }
                      }}
                    >
                      {replyLoading ? (
                        // 🔥 TAILWIND SPINNER (NO SVG)
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      ) : (
                        <img
                          src="/LibraryImg/send.png"
                          alt="send"
                          className="w-5 h-5"
                        />
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* PDF viewer / full-size image or video modal */}
          {pedingSubDetail.pdfView && (
            <PdfViewer
              handleRemovePdfVivwer={handleRemovePdfVivwer}
              attachment={responseAttach}
            />
          )}

          {isClicked &&
            (responseAttach.split(".").pop() === "mp4" ||
              responseAttach.split(".").pop() === "MP4" ? (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
                <div className="bg-black rounded-md overflow-hidden w-11/12 md:w-3/4 lg:w-2/3">
                  <div className="relative">
                    <video className="w-full h-auto" controls>
                      <source
                        src={IP + responseAttach.replace(/^\./, "")}
                        type="video/mp4"
                      />
                    </video>
                    <button
                      className="absolute top-3 right-3 p-2 rounded bg-white/80"
                      onClick={handleClick}
                    >
                      <img
                        src="/DCM-img/crossIcon.svg"
                        alt="close"
                        className="w-4 h-4"
                      />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
                <div className="bg-white rounded-md overflow-hidden w-11/12 md:w-3/4 lg:w-2/3 p-4">
                  {!isError ? (
                    <>
                      <img
                        src={IP + responseAttach?.replace(/^\./, "")}
                        alt="Full-size"
                        className="mx-auto max-h-[70vh] object-contain"
                        onError={() => setIsError(true)}
                      />
                      <div className="absolute top-4 right-4">
                        <button
                          onClick={handleClick}
                          className="p-2 rounded bg-white"
                        >
                          <img
                            src="/images/cross.png"
                            alt="close"
                            className="w-5 h-5"
                          />
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="flex flex-col items-center p-8">
                      <img
                        onClick={() => {
                          setIsError(false);
                          handleClick();
                        }}
                        src="/images/cross.png"
                        alt="close"
                        className="w-8 h-8 mb-4"
                      />
                      <img
                        src="/images/no-photo1.png"
                        alt="not found"
                        className="w-1/4 mb-4"
                      />
                      <p className="text-red-500 font-semibold text-lg">
                        Error!! failed to load the requested file!
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}

          {/* Delete / Resolve / Bookmark Popups */}
          {deleteQuery && (
            <DeleteQueryLib
              setDeleteQuery1={() => {
                setDeleteQuery();
              }}
              setComponentRerenderFlag={setComponentRerenderFlag}
              queryId={clickedQuery.id}
              userId={userDetail.id}
            />
          )}

          {markQuery && (
            <ResolveQueryLib
              setMarkQuery={setMarkQuery}
              data={clickedQuery}
            />
          )}

          {viewErrorPop && (
            <CreateBookMarkPopup
              setViewErrorPop={setViewErrorPop}
              errorMsg={errorMsg}
            />
          )}
        </div>
      </div>
    ))
  );
}
